const TOC_NAV_ITEMS = {
    aboutNav: {
        anchor: '#cg-about-carrier-title-section',
        text: 'tocLinkAbout',
    },
    bestNav: {
        anchor: '#carrier-best-section',
        text: 'tocLinkBest',
    },
    reviewNav: {
        anchor: '#carrier-review-section',
        text: 'tocLinkReview',
    },
    mapNav: {
        anchor: '#route-map-header',
        text: 'tocLinkMap',
    },
    popularTripNav: {
        anchor: '#top-routes-section',
        text: 'tocLinkPopularTrip',
    },
    cancellationNav: {
        anchor: '#carrier-cancellation',
        text: 'tocLinkCancel',
    },
    faqNav: {
        anchor: '#faq-header-section',
        text: 'tocLinkFAQ',
    },
    cheapTripNav: {
        anchor: '#cg-cheapest-routes-title-section',
        text: 'tocLinkCheapTrip',
    },
    relatedReadingsNav: {
        anchor: '#blog-section',
        text: 'tocBlog',
    },
};

const POLICY_CONTENT = [
    {
        title: 'baggagePolicyTitle',
        description: 'baggagePolicyContent',
    },
    {
        title: 'disabilityTitle',
        description: 'disabilityContent',
    },
    {
        title: 'groupTravelTitle',
        description: 'groupTravelContent',
    },
];

const CARRIER_CONTENT = [
    {
        title: 'bestDealTitle',
        description: 'bestDealContent',
    },
    {
        title: 'sustainabilityTitle',
        description: 'sustainabilityContent',
    },
    {
        title: 'safetyTitle',
        description: 'safetyContent',
    },
];

export {
    CARRIER_CONTENT,
    POLICY_CONTENT,
    TOC_NAV_ITEMS,
};
